export function getParticipantLayoutPageCount(itemCount, pageSize) {
  const safeItemCount = Number.isFinite(itemCount) ? Math.max(0, Math.floor(itemCount)) : 0;
  const safePageSize = Number.isFinite(pageSize) ? Math.max(1, Math.floor(pageSize)) : 1;

  return Math.max(1, Math.ceil(safeItemCount / safePageSize));
}

export function clampParticipantLayoutPageIndex(pageIndex, pageCount) {
  const safePageIndex = Number.isFinite(pageIndex) ? Math.max(0, Math.floor(pageIndex)) : 0;
  const safePageCount = Number.isFinite(pageCount) ? Math.max(1, Math.floor(pageCount)) : 1;

  return Math.min(safePageIndex, safePageCount - 1);
}

export function getParticipantLayoutPage({ items = [], pageIndex = 0, pageSize = 1 } = {}) {
  const safePageSize = Number.isFinite(pageSize) ? Math.max(1, Math.floor(pageSize)) : 1;
  const pageCount = getParticipantLayoutPageCount(items.length, safePageSize);
  const currentPageIndex = clampParticipantLayoutPageIndex(pageIndex, pageCount);
  const startIndex = currentPageIndex * safePageSize;

  return {
    items: items.slice(startIndex, startIndex + safePageSize),
    pageCount,
    pageIndex: currentPageIndex,
    pageSize: safePageSize
  };
}
